import { Spacing } from '@vkontakte/vkui';
import React, { type ReactElement, memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FeaturesList } from 'reactApp/components/VkBuyModalWithSidebar/FastCheckoutSidebar/FeaturesList';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { useGoToSubscriptions } from 'reactApp/hooks/useGoToSubscriptions';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { getDiscount } from 'reactApp/utils/getDiscount';

import styles from './FastCheckoutLightSidebar.css';
import type { FastCheckoutLightSidebarProps } from './FastCheckoutLightSidebar.types';

export const FastCheckoutLightSidebar = memo(
    ({ product, onClickTariffs, featuresList: customFeaturesList, hideOtherTariffs }: FastCheckoutLightSidebarProps): ReactElement => {
        const { goToSubscriptions } = useGoToSubscriptions();

        const { space, discountPrice, price, hasTrial } = product;

        const { discount } = getDiscount({ discountPrice: discountPrice || 0, price });

        const storage = useSelector(getCurrentStorage) as EStorageType;
        const { isQuotaCleaner } = getStorage(storage);

        const clickTariffs = useCallback(() => {
            onClickTariffs();

            goToSubscriptions({
                inSameTab: false,
                isNewTariffsPage: true,
                query: PaymentUTM.fastcheckout,
            });
        }, [onClickTariffs, goToSubscriptions]);

        return (
            <div className={styles.root}>
                <div className={styles.tariffInfo}>
                    <div className={styles.label}>{product.hasDiscount && !product.hasTrial ? `Скидка ${discount}%` : 'Mail Space'}</div>

                    <div className={styles.header}>
                        <div className={styles.quota}>+{space.space}</div>
                        <div className={styles.units}>{space.units}</div>
                    </div>

                    <FeaturesList customList={customFeaturesList} product={product} noBorder decreaseFontScale isExpandedList />

                    {!hideOtherTariffs && !isQuotaCleaner && !hasTrial && (
                        <>
                            <Spacing size={14} />
                            <div className={styles.tariffsLink} onClick={clickTariffs}>
                                Другие тарифы
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
);

FastCheckoutLightSidebar.displayName = 'FastCheckoutSidebar';
